module.exports={
    "created_at": "2017-01-24T21:25:03+00:00",
    "routes_server": [
        {
            "data": [
                {
                    "route": "/most-creative-people",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderMCP1000",
                    "view": {
                        "route": "most-creative-people",
                        "alias": "mcp-1000",
                        "file": "js/mcp-1000.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/mcp-1000/js/mcp-1000.js"
                },
                {
                    "route": "/most-creative-people/",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderMCP1000",
                    "view": {
                        "route": "most-creative-people/",
                        "alias": "mcp-1000/",
                        "file": "js/mcp-1000.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/mcp-1000/js/mcp-1000.js"
                },
                {
                    "route": "/mcp",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderMCP1000",
                    "view": {
                        "route": "mcp",
                        "alias": "mcptest",
                        "file": "js/mcp-1000.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/mcp-1000/js/mcp-1000.js"
                },
                {
                    "route": "/mcp/",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderMCP1000",
                    "view": {
                        "route": "mcp/",
                        "alias": "mcptest/",
                        "file": "js/mcp-1000.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/mcp-1000/js/mcp-1000.js"
                }
            ],
            "path": "/app/client/mcp-1000/"
        },
        {
            "data": [
                {
                    "route": "/most-creative-people/:year",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderMCP",
                    "view": {
                        "route": "mcp/:year",
                        "alias": "mcp-year",
                        "file": "js/mcp.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/mcp/js/mcp.js"
                },
                {
                    "route": "/mcp/:year",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderMCP",
                    "view": {
                        "route": "mcptest/:year",
                        "alias": "mcptest-year",
                        "file": "js/mcp.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/mcp/js/mcp.js"
                }
            ],
            "path": "/app/client/mcp/"
        },
        {
            "data": [
                {
                    "route": "/person",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderPersonIndex",
                    "view": {
                        "route": "person",
                        "alias": "person-index",
                        "file": "js/person-index.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/person-index/js/person-index.js"
                }
            ],
            "path": "/app/client/person-index/"
        },
        {
            "data": [
                {
                    "route": "/person/:person_url",
                    "method": [
                        "GET"
                    ],
                    "controller": "renderPerson",
                    "view": {
                        "route": "person/:person_url",
                        "alias": "person",
                        "file": "js/person.js"
                    },
                    "timeout": 2000,
                    "path": "app/client/person/js/person.js"
                }
            ],
            "path": "/app/client/person/"
        }
    ],
    "routes_api": [
        {
            "data": [
                {
                    "route": "/api/v1/ping",
                    "method": [
                        "GET",
                        "POST"
                    ],
                    "controller": "processPing",
                    "timeout": 2000
                }
            ],
            "path": "/api/v1/ping/"
        }
    ],
    "template_paths": [
        "app/templates",
        "app/client/mcp-1000/",
        "app/client/mcp/",
        "app/client/person-index/",
        "app/client/person/"
    ]
}
